import { gql } from '@apollo/client';

export const EXPORT_SERVICE_PROVIDERS = gql`
  query ExportServiceProviders($input: ExportArgs!) {
    exportServiceProviders(input: $input) {
      id
      legalStructure
      roles
      type
      address
      contactNumber
      description
      email
      execInCharge
      firstContactPerson
      firstContactPersonEmail
      firstContactPersonNumber
      logo
      name
      orgLeader
      physicalAddress
      registrationNumber
      secondContactPerson
      secondContactPersonEmail
      secondContactPersonNumber
      title
      website
      programmes {
        id
        name
      }
    }
  }
`;
